async function recaptchaLoad ($requestor) {
	await this.$recaptchaLoaded()

	const token = await this.$recaptcha($requestor)

	localStorage.setItem('captcha', token)
}

export default {
	recaptchaLoad
};